<template>
  <div v-if="!loading">
    <keep-alive>
      <router-view :key="key" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
    <van-popup
      safe-area-inset-bottom
      style="background:transparent;margin-top:-80px"
      v-model="show"
    >
      <div class="vipimgbox">
        <img style="width:330px" src="@/assets/img/vipPost.png" alt="" />
        <div @click.stop="backvip" class="btn"></div>
        <div @click.stop="show = false" class="close"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { wxuser, getFreeFTVip } from '@/api/base';
import { formatDateTimeRT } from '@/utils/index';
import { asyncIsVip } from '@/utils/isVip';

export default {
  data() {
    return {
      loading: false,
      show: false,
    };
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  created() {
    console.log(this.$route);
    this.getUserinfo();
  },
  methods: {
    getUserinfo() {
      this.loading = true;
      wxuser().then(res => {
        if (res.data.wxUser.isReceiveFt == 0) {
          this.show = true;
        } else if (this.$route.path != '/postView') {
          asyncIsVip(2, 'noFetch', res);
        }
        this.loading = false;
      });
    },
    backvip() {
      getFreeFTVip().then(res => {
        this.$toast('恭喜您领取成功！');
        this.show = false;
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.vipimgbox {
  position: relative;
  width: 330px;
}
.vipimgbox img {
  display: block;
  width: 100%;
  height: auto;
}
.vipimgbox .btn {
  width: 200px;
  height: 40px;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
}
.vipimgbox .close {
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 0;
  left: 53%;
  transform: translateX(-50%);
}
.vip15day .btn {
  bottom: 72px;
}
.vip15day .close {
  bottom: 28px;
}
</style>
